import axiosInstance from "../lib/axiosInstance";

class notificationModel {
  constructor() {
    this.base_url = "/notifications";
  }
  async list(query = {}) {
    return (
      await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)
    ).data;
  }

  async read_at(id) {
    return await axiosInstance.post(`${this.base_url}/${id}/read`);
  }
}

export default new notificationModel();